export default {
  id: '02534345',
  type: 'voucher',
  category: 'basic',
  // active: false, ?
  content: {
    text: 'VOUCHER',
  },
  settings: {},
  // Ex. maxLetters: 0,
  /*  Keep the styling even in flattened json structure cause vue ease of use */
  styling: {
    fontFamily: 'Roboto',
    fontSize: '22px',
    fontWeight: 'normal',
    color: 'rgb(24, 23, 26)',
    textAlign: 'center',
    borderRadius: '0px',
    borderWidth: '2px',
    borderColor: '#000000',
  },
}
